/**
 * 根據任務狀態匹配對應的顏色
 * 
 * @param {string|number} taskStatus - 任務狀態
 * @returns {string} 對應的顏色名稱
 */
export const matchTaskStatusColors = (taskStatus) => {
    switch (String(taskStatus)) {
        case '1':
        case '3':
        case '2':
        case '4':
            return 'info';
        case '5':
            return 'success';
        case '7':
        case '8':
        case '9':
            return 'error';
        default:
            return 'gray';
        // return 'warning';
    }
};
